module.exports = __webpack_public_path__ + "img/GAME_PAINTBALL.e6b3bf9d.jpg";